// extracted by mini-css-extract-plugin
export var active = "_bi-7";
export var container = "_bi-0";
export var evenWidth = "_bi-4";
export var large = "_bi-5";
export var outlet = "_bi-8";
export var slide = "_bi-2";
export var small = "_bi-6";
export var tab = "_bi-3";
export var tabs = "_bi-1";